export const FORM_FIELDS = {
  PERSON_LOCATION_TYPES: 'personLocationTypes',
  MOBILE_LOCATION_SCOPE: 'mobileLocationScope',
};
